import CostAllocationReport from "./components/nc/CostAllocationReport";
import CompanySetup from "./components/pages/admin/CompanySetup";
import "./App.css";
import React, { lazy, Suspense } from "react";
import ComenziProdMasterDetail from "./components/productie/comenzi/ComenziProdMasterDetail";
import ComenziProdPrint from "./components/productie/comenzi/ComenziProdPrint";
import Home from "./components/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BxcustomerList from "./components/BxcustomerList";
import CreateBxcustomer from "./components/CreateBxcustomer";
import InvoiceList from "./components/InvoiceList";
import CreateInvoice from "./components/CreateInvoice";
import EditBxcustomer from "./components/EditBxcustomer";
import AgentList from "./components/agent/AgentList";
import AgentCreate from "./components/agent/AgentCreate";
import AgentEdit from "./components/agent/AgentEdit";
import BxgestiuneList from "./components/bxgestiune/BxgestiuneList";
import BxgestiuneCreate from "./components/bxgestiune/BxgestiuneCreate";
import BxgestiuneEdit from "./components/bxgestiune/BxgestiuneEdit";
import DocTypeCfgList from "./components/doc_type_cfg/DocTypeCfgList";
import DocTypeCfgCreate from "./components/doc_type_cfg/DocTypeCfgCreate";
import DocTypeCfgEdit from "./components/doc_type_cfg/DocTypeCfgEdit";
import FirmaList from "./components/firma/FirmaList";
import FirmaCreate from "./components/firma/FirmaCreate";
import FirmaEdit from "./components/firma/FirmaEdit";
import MagazinOnline from "./components/firma/MagazinOnline";
import BxcentrucostList from "./components/bxcentrucost/BxcentrucostList";
import BxcentrucostCreate from "./components/bxcentrucost/BxcentrucostCreate";
import BxcentrucostEdit from "./components/bxcentrucost/BxcentrucostEdit";
import TipFacturaIesireList from "./components/tip_factura_iesire/TipFacturaIesireList";
import TipFacturaIesireCreate from "./components/tip_factura_iesire/TipFacturaIesireCreate";
import TipFacturaIesireEdit from "./components/tip_factura_iesire/TipFacturaIesireEdit";
import BranchesList from "./components/branches/BranchesList";
import BranchesCreate from "./components/branches/BranchesCreate";
import BranchesEdit from "./components/branches/BranchesEdit";

import TipFacturaIntrareList from "./components/tip_factura_intrare/TipFacturaIntrareList";
import TipFacturaIntrareCreate from "./components/tip_factura_intrare/TipFacturaIntrareCreate";
import TipFacturaIntrareEdit from "./components/tip_factura_intrare/TipFacturaIntrareEdit";
import EditInvoice from "./components/EditInvoice";

import AccountsList from "./components/accounts/AccountsList";
import AccountCreate from "./components/accounts/AccountCreate";
import AccountEdit from "./components/accounts/AccountEdit";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import BxunitateList from "./components/bxunitate/BxunitateList";

import BxumList from "./components/bxum/BxumList";
import BxumEdit from "./components/bxum/BxumEdit";
import BxumCreate from "./components/bxum/BxumCreate";

import RequireAuth from "./components/auth/RequireAuth";
import Login from "./components/auth/Login";

import SursaList from "./components/sursa/SursaList";
import SursaCreate from "./components/sursa/SursaCreate";
import SursaEdit from "./components/sursa/SursaEdit";

import AuthProvider from "./components/auth/AuthContext";

import BxvatList from "./components/bxvat/BxvatList";
import BxvatCreate from "./components/bxvat/BxvatCreate";
import BxvatEdit from "./components/bxvat/BxvatEdit";

import ContacteList from "./components/contacte/ContacteList";
import ContacteCreate from "./components/contacte/ContacteCreate";
import ContacteEdit from "./components/contacte/ContacteEdit";
import Walkthrough from "./components/Walkthrough";

import CatalogList from "./components/catalog/CatalogList";
import CatalogCreate from "./components/catalog/CatalogCreate";
import CatalogEdit from "./components/catalog/CatalogEdit";

import JudetList from "./components/judet/JudetList";
import IntrarePage from "./components/intrare/IntrarePage";

import IntrareList from "./components/intrare/List";
import IntrareCreate from "./components/intrare/Create";
import IntrareEdit from "./components/intrare/Edit";

import GrupaProduseList from "./components/grupa_produse/GrupaProduseList";
import GrupaProduseCreate from "./components/grupa_produse/GrupaProduseCreate";
import GrupaProduseEdit from "./components/grupa_produse/GrupaProduseEdit";

import BxpartList from "./components/bxpart/BxpartList";
import BxpartCreate from "./components/bxpart/BxpartCreate";
import BxpartEdit from "./components/bxpart/BxpartEdit";
import AppLayout from "./components/AppLayout";

import BxvalutaList from "./components/bxvaluta/BxvalutaList";
import BxvalutaCreate from "./components/bxvaluta/BxvalutaCreate";
import BxvalutaEdit from "./components/bxvaluta/BxvalutaEdit";

import NirList from "./components/nir/List";
import NirCreate from "./components/nir/Create";
import NirEdit from "./components/nir/Edit";

import ProcesVerbalList from "./components/proces_verbal/List";
import ProcesVerbalCreate from "./components/proces_verbal/Create";
import ProcesVerbalEdit from "./components/proces_verbal/Edit";

import BonConsumList from "./components/bon_consum/List";
import BonConsumCreate from "./components/bon_consum/Create";
import BonConsumEdit from "./components/bon_consum/Edit";

import BonProductieList from "./components/bon_productie/List";
import BonProductieCreate from "./components/bon_productie/Create";
import BonProductieEdit from "./components/bon_productie/Edit";

import RecipeList from "./components/recipes/List";
import RecipeCreate from "./components/recipes/Create";
import RecipeEdit from "./components/recipes/Edit";

import StocCurentList from "./components/stock/CurrentList.jsx";
import TipBonIesire from "./components/tip_bon_iesire/TipBonIesireList.jsx";
import TipBonIesireCreate from "./components/tip_bon_iesire/TipBonIesireCreate.jsx";
import TipBonIesireEdit from "./components/tip_bon_iesire/TipBonIesireEdit.jsx";

import BonTransferList from "./components/bon_transfer/BonTransferList.jsx";
import BonTransferCreate from "./components/bon_transfer/BonTransferCreate.jsx";
import BonTransferEdit from "./components/bon_transfer/BonTransferEdit.jsx";

import BxInventarList from "./components/bxinventar/List.jsx";
import BxInventarCreate from "./components/bxinventar/Create.jsx";
import BxInventarEdit from "./components/bxinventar/Edit.jsx";

import IesireList from "./components/iesire/List";
import IesireCreate from "./components/iesire/Create";
import IesireEdit from "./components/iesire/Edit";

import { CashDocCreate } from "./components/cash/Create";
import { CashDocEdit } from "./components/cash/Edit";
import { CashDocList } from "./components/cash/List";
import RestFurnizori from "./components/intrare/RestFurnizori";
import IesirePrint from "./components/iesire/IesirePrint";
import NirPrint from "./components/nir/NirPrint";
import BonConsumPrint from "./components/bon_consum/BonConsumPrint";
import BonTransferPrint from "./components/bon_transfer/BonTransferPrint";
import ProcesVerbalPrint from "./components/proces_verbal/ProcesVerbalPrint";
import DevizPrint from "./components/comenzi/DevizPrint";
import ServiceAnnexPrint from "./components/comenzi/ServiceAnnexPrint";
import ReportHome from "./components/reports/ReportHome";
import JurnalTvaPrint from "./components/reports/JurnalTVAPrint";
import JurnalTva from "./components/reports/JurnalTva";
import JurnalTvaIntrariIncasare from "./components/reports/JurnalTvaIntrariIncasare";
import JurnalTvaValuta from "./components/reports/JurnalTvaValuta";
import JurnalTvaIesiriIncasare from "./components/reports/JurnalTvaIesiriIncasare";
import JurnalTvaIesiriValuta from "./components/reports/JurnalTvaIesiriValuta";
import RapoarteService from "./components/reports/RapoarteService";
import RapoarteProductie from "./components/reports/RapoarteProductie";
import Rapoarte from "./components/reports/Rapoarte";
import RapoarteIntrari from "./components/reports/RapoarteIntrari";
import RapoarteIesiri from "./components/reports/RapoarteIesiri";
import RapoarteCasa from "./components/reports/RapoarteCasa";
import RaportCasaZilnic from "./components/reports/RaportCasaZilnic.jsx";
import RapoarteStoc from "./components/reports/RapoarteStoc";
import FisaMagazie from "./components/reports/FisaMagazie";
import ScaderiMateriale from "./components/reports/ScaderiMateriale";
import RapoarteContabilitate from "./components/reports/RapoarteContabilitate";
import Balanta from "./components/reports/Balanta";
import FisaCont from "./components/reports/FisaCont";
import Bilant from "./components/reports/Bilant";
import SuperadminDashboard from "./components/superadmin/SuperadminDashboard.jsx";

import ContCcMapPage from "./components/cont_cc_map/ContCcMapPage";
import ContCcMapCreate from "./components/cont_cc_map/ContCcMapCreate";
import ContCcMapList from "./components/cont_cc_map/ContCcMapList";
import Register from "./components/pages/RegisterNew";
import UserRightsPage from "./components/pages/admin/UserRightsPage";
import RolesPage from "./components/pages/admin/RolesPage";
import UserListPage from "./components/pages/admin/UserListPage";
import EFacturaList from "./components/efactura/EFacturaList";
import NcList from "./components/nc/List";
import NcView from "./components/nc/View";
import NcCreate from "./components/nc/Create";
import NcEdit from "./components/nc/Edit";
import InchideLuna from "./components/nc/InchideLuna";

import D300List from "./components/d300/D300List";
import D300Edit from "./components/d300/D300Edit";
import D394List from "./components/d394/D394List";
import D394Edit from "./components/d394/D394Edit";
import D406List from "./components/d406/D406List";
import D406Edit from "./components/d406/D406Edit";

import ImportBalanta from "./components/imports/ImportBalanta";
import ImportFacturi from "./components/imports/ImportFacturi";
import ImportStoc from "./components/imports/ImportStoc";
import ImportMf from "./components/imports/ImportMf";
import ClientOrderLinesList from "./components/comenzi/List";
import ClientOrderCreate from "./components/comenzi/Create";
import ClientOrderPrint from "./components/comenzi/ClientOrderPrint";
import InternalOrdersList from "./components/comenzi/InternList";
import CoduriManopera from "./components/comenzi/CoduriManopera";
import CoduriManoperaProd from "./components/productie/CoduriManoperaProd";
import Angajati from "./components/comenzi/Angajati";
import RaportAngajati from "./components/comenzi/RaportAngajati";
import RaportNecesarAprovizionare from "./components/reports/RaportNecesarAprovizionare";

import RaportConsumProd from "./components/reports/RaportConsumProd";
import RaportIstoricSasiu from "./components/reports/RaportIstoricSasiu";
import RaportProfitabilitateService from "./components/reports/RaportProfitabilitateService";



import MijloaceFixeList from "./components/mijloace_fixe/MijloaceFixeList";
import MijloaceFixeCreate from "./components/mijloace_fixe/MijloaceFixeCreate";
import MijloaceFixeEdit from "./components/mijloace_fixe/MijloaceFixeEdit";
import ObInvList from "./components/obinv/ObInvList";
import ObInvForm from "./components/obinv/ObInvForm";
import TransferObInvList from "./components/obinv/TransferObInvList";
import TransferObInvForm from "./components/obinv/TransferObInvForm";
import ObInvRaportStoc from "./components/obinv/ObInvRaportStoc";
import CasariList from "./components/obinv/CasariList";
import CasariForm from "./components/obinv/CasariForm";
import ObInvIstoricMiscari from "./components/obinv/ObInvIstoricMiscari";
import IstoricList from "./components/istoric/IstoricList";
import Landing from "./components/Landing";

// Contor Variant Components
import ContorTransferEquipment from "./components/contor/TransferEquipment";
import ContorClientBilling from "./components/contor/ClientBilling";
import ContorBilling from "./components/contor/Billing";
import ContorContractForm from "./components/contor/ContractForm";
import ContorContracts from "./components/contor/Contracts";
import GrupeList from "./components/contor/grupe/List";
import GrupaForm from "./components/contor/grupe/Form";
import EchipamenteList from "./components/contor/echipamente/List";
import EchipamentForm from "./components/contor/echipamente/Form";
import SesizariList from "./components/contor/sesizari/List";
import SesizareForm from "./components/contor/sesizari/Form";

const SalariiPage = lazy(() => import("./salarii/SalariiPage"));
const SantierPage = lazy(() => import("./santier/SantierPage"));

function App() {
  React.useEffect(() => {
    const disableAutocompleteForElement = (el) => {
      if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
        el.setAttribute("autocomplete", "nope");
      } else if (el.tagName === "FORM") {
        el.setAttribute("autocomplete", "off");
      }
    };

    // Aplicam pe cele existente la montare
    document
      .querySelectorAll("input, textarea, form")
      .forEach(disableAutocompleteForElement);

    // Handler focus
    const handleFocus = (e) => {
      if (e.target) {
        disableAutocompleteForElement(e.target);
      }
    };
    document.addEventListener("focusin", handleFocus);

    // Observer pentru elemente dinamice adaugate de React
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            disableAutocompleteForElement(node);
            node
              .querySelectorAll("input, textarea, form")
              .forEach(disableAutocompleteForElement);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      document.removeEventListener("focusin", handleFocus);
      observer.disconnect();
    };
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/landing" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route element={<AppLayout />}>
            <Route path="/santier" element={<Suspense fallback={<div className="container py-4" role="status">Se încarcă modulul Șantier…</div>}><SantierPage /></Suspense>} />
            <Route path="/salarii" element={<Suspense fallback={<div className="container py-4" role="status">Se încarcă modulul Salarii…</div>}><SalariiPage /></Suspense>} />
            <Route path="/comenzi-prod" element={<ComenziProdMasterDetail />} />
            <Route path="/comenzi-prod/:id/print" element={<ComenziProdPrint />} />
            <Route path="/" element={<Home />} />
            <Route path="/configurare-ghidata" element={<CompanySetup />} />
            <Route path="/branches" element={<BranchesList />} />
            <Route path="/branches/create" element={<BranchesCreate />} />
            <Route path="/branches/:id" element={<BranchesEdit />} />
            <Route path="/bxcentrucost" element={<BxcentrucostList />} />
            <Route path="/bxcentrucost/create" element={<BxcentrucostCreate />} />
            <Route path="/bxcentrucost/:id" element={<BxcentrucostEdit />} />
            <Route path="/firma" element={<FirmaList />} />
            <Route path="/firma/create" element={<FirmaCreate />} />
            <Route path="/firma/:id" element={<FirmaEdit />} />
            <Route path="/magazin-online" element={<MagazinOnline />} />
            <Route path="/magazin-online/produse" element={<MagazinOnline section="products" />} />
            <Route path="/magazin-online/produse-existente" element={<MagazinOnline section="existing" />} />
            <Route path="/magazin-online/comenzi" element={<MagazinOnline section="orders" />} />
            <Route path="/superadmin/dashboard" element={<SuperadminDashboard />} />
            <Route path="/customerlist" element={<BxcustomerList />} />
            <Route path="/createbxcustomer" element={<CreateBxcustomer />} />
            <Route path="/createinvoice" element={<CreateInvoice />} />
            <Route path="/listinvoice" element={<InvoiceList />} />
            <Route path="/editinvoice/:id" element={<EditInvoice />} />
            <Route path="/editbxcustomer/:id" element={<EditBxcustomer />} />
            <Route path="/bxcustomer/delete/:id" element={<BxcustomerList />} />
            <Route path="/accounts" element={<AccountsList />} />
            <Route path="/accounts/create" element={<AccountCreate />} />
            <Route path="/accounts/edit/:id" element={<AccountEdit />} />
            <Route path="/accounts/delete/:id" element={<AccountsList />} />
            <Route path="/accounts/:id" element={<AccountEdit />} />
            <Route path="/bxunitate" element={<BxunitateList />} />
            <Route path="/bxum" element={<BxumList />} />
            <Route path="/bxum/new" element={<BxumCreate />} />
            <Route path="/bxum/:id/edit" element={<BxumEdit />} />
            {/* aliasuri compatibile cu vechiul plural */}
            <Route path="/bxums" element={<BxumList />} />
            <Route path="/bxums/create" element={<BxumCreate />} />
            <Route path="/bxums/:id" element={<BxumEdit />} />
            <Route path="/bxums/:id/edit" element={<BxumEdit />} />
            <Route path="/bxvat" element={<BxvatList />} />
            <Route path="/bxvat/:id" element={<BxvatEdit />} />
            <Route path="/bxvat/create" element={<BxvatCreate />} />
            <Route path="/bxvat/edit/:id" element={<BxvatEdit />} />
            <Route path="/bxvat/delete/:id" element={<BxvatList />} />
            <Route path="/judet" element={<JudetList />} />
            <Route path="/contacte" element={<ContacteList />} />
            <Route path="/contacte/:id" element={<ContacteEdit />} />
            <Route path="/contacte/create" element={<ContacteCreate />} />
            <Route path="/contacte/edit/:id" element={<ContacteEdit />} />
            <Route path="/contacte/delete/:id" element={<ContacteList />} />
            <Route path="/walkthrough" element={<Walkthrough />} />
            <Route path="/catalog" element={<CatalogList />} />
            <Route path="/catalog/create" element={<CatalogCreate />} />
            <Route path="/catalog/:id" element={<CatalogEdit />} />
            <Route path="/sursa" element={<SursaList />} />
            <Route path="/sursa/:id" element={<SursaEdit />} />
            <Route path="/sursa/create" element={<SursaCreate />} />
            <Route path="/sursa/edit/:id" element={<SursaEdit />} />
            <Route path="/sursa/delete/:id" element={<SursaList />} />
            {/* <Route path="/intrare" element={<IntrarePage  />} /> */}
            <Route path="/grupa_produse" element={<GrupaProduseList />} />
            <Route path="/grupa_produse/:id" element={<GrupaProduseEdit />} />
            <Route
              path="/grupa_produse/create"
              element={<GrupaProduseCreate />}
            />
            <Route path="/bxpart" element={<BxpartList />} />
            <Route path="/bxpart/create" element={<BxpartCreate />} />
            <Route path="/bxpart/:id" element={<BxpartEdit />} />
            <Route path="/bxvaluta" element={<BxvalutaList />} />
            <Route path="/bxvaluta/create" element={<BxvalutaCreate />} />
            <Route path="/bxvaluta/:id" element={<BxvalutaEdit />} />
            <Route path="/agent" element={<AgentList />} />
            <Route path="/agent/create" element={<AgentCreate />} />
            <Route path="/agent/:id" element={<AgentEdit />} />
            <Route path="/intrare" element={<IntrareList />} />
            <Route path="/intrare/new" element={<IntrareCreate />} />
            <Route path="/intrare/:id/edit" element={<IntrareEdit />} />
            <Route path="/nir" element={<NirList />} />
            <Route path="/nir/new" element={<NirCreate />} />
            <Route path="/nir/:id/edit" element={<NirEdit />} />
            <Route path="/bxgestiune" element={<BxgestiuneList />} />
            <Route path="/bxgestiune/create" element={<BxgestiuneCreate />} />
            <Route path="/bxgestiune/:id" element={<BxgestiuneEdit />} />
            <Route path="/doc_type_cfg" element={<DocTypeCfgList />} />
            <Route path="/doc_type_cfg/create" element={<DocTypeCfgCreate />} />
            <Route path="/doc_type_cfg/:id" element={<DocTypeCfgEdit />} />
            <Route path="/stock/curent" element={<StocCurentList />} />
            <Route path="/proces-verbal" element={<ProcesVerbalList />} />
            <Route path="/proces-verbal/new" element={<ProcesVerbalCreate />} />
            <Route
              path="/proces-verbal/:id/edit"
              element={<ProcesVerbalEdit />}
            />
            <Route path="/proces_verbal" element={<ProcesVerbalList />} />
            <Route path="/proces_verbal/new" element={<ProcesVerbalCreate />} />
            <Route
              path="/proces_verbal/:id/edit"
              element={<ProcesVerbalEdit />}
            />
            <Route path="/bon-consum" element={<BonConsumList />} />
            <Route path="/bon-consum/new" element={<BonConsumCreate />} />
            <Route path="/bon-consum/:id" element={<BonConsumEdit />} />

            <Route path="/bon-productie" element={<BonProductieList />} />
            <Route path="/bon-productie/new" element={<BonProductieCreate />} />
            <Route path="/bon-productie/:id" element={<BonProductieEdit />} />

            <Route path="/retete" element={<RecipeList />} />
            <Route path="/retete/new" element={<RecipeCreate />} />
            <Route path="/retete/:id" element={<RecipeEdit />} />
            <Route path="/tip-bon-iesire" element={<TipBonIesire />} />
            <Route
              path="/tip-bon-iesire/create"
              element={<TipBonIesireCreate />}
            />
            <Route path="/tip-bon-iesire/:id" element={<TipBonIesireEdit />} />
            <Route path="/bon-transfer" element={<BonTransferList />} />
            <Route
              path="/bon-transfer/create"
              element={<BonTransferCreate />}
            />
            <Route path="/bon-transfer/:id" element={<BonTransferEdit />} />
            <Route path="/bxinventar" element={<BxInventarList />} />
            <Route path="/bxinventar/new" element={<BxInventarCreate />} />
            <Route path="/bxinventar/:id/edit" element={<BxInventarEdit />} />
            <Route path="/mijloace-fixe" element={<MijloaceFixeList />} />
            <Route path="/mijloace-fixe/new" element={<MijloaceFixeCreate />} />
            <Route path="/mijloace-fixe/:id" element={<MijloaceFixeEdit />} />
            <Route path="/tip-bon-iesire" element={<TipBonIesire />} />
            <Route path="/iesire" element={<IesireList />} />
            <Route path="/iesire/new" element={<IesireCreate />} />
            <Route path="/iesire/:id" element={<IesireEdit />} />
            <Route path="/iesire/:id/stocout" element={<IesireEdit />} />
            <Route
              path="/tip_factura_iesire"
              element={<TipFacturaIesireList />}
            />
            <Route
              path="/tip_factura_iesire/create"
              element={<TipFacturaIesireCreate />}
            />
            <Route
              path="/tip_factura_iesire/:id"
              element={<TipFacturaIesireEdit />}
            />
            <Route
              path="/tip_factura_intrare"
              element={<TipFacturaIntrareList />}
            />
            <Route
              path="/tip_factura_intrare/create"
              element={<TipFacturaIntrareCreate />}
            />
            <Route
              path="/tip_factura_intrare/:id"
              element={<TipFacturaIntrareEdit />}
            />
            <Route path="/cash/new" element={<CashDocCreate />} />
            <Route path="/cash/:id" element={<CashDocEdit />} />
            <Route path="/cash" element={<CashDocList />} />
            <Route path="/intrare/rest/sumar" element={<RestFurnizori />} />
            <Route path="/iesire/:id/print" element={<IesirePrint />} />
            <Route path="/nir/:id/print" element={<NirPrint />} />
            <Route path="/bon-consum/:id/print" element={<BonConsumPrint />} />
            <Route path="/bon-transfer/:id/print" element={<BonTransferPrint />} />
            <Route path="/proces-verbal/:id/print" element={<ProcesVerbalPrint />} />
            <Route path="/proces_verbal/:id/print" element={<ProcesVerbalPrint />} />
            <Route path="/comenzi/interna/:id/print" element={<DevizPrint />} />
            <Route path="/comenzi/interna/:id/anexe/:annexId/print" element={<ServiceAnnexPrint />} />
            {/*                         <Route path="/rapoarte/service" element={<RapoarteService />} />
            <Route path="/rapoarte/productie" element={<RapoarteProductie />} />
            <Route path="/rapoarte" element={<Rapoarte />} /> */}
            {/* <Route path="/rapoarte" element={<ReportHome />} /> */}
                                    <Route path="/rapoarte/service" element={<RapoarteService />} />
            <Route path="/rapoarte/productie" element={<RapoarteProductie />} />
            <Route path="/rapoarte" element={<Rapoarte />} />
            <Route path="/rapoarte/intrari" element={<RapoarteIntrari />} />
            <Route path="/rapoarte/iesiri" element={<RapoarteIesiri />} />
            <Route path="/rapoarte/casa" element={<RapoarteCasa />} />
            <Route path="/rapoarte/casa-zilnic" element={<RaportCasaZilnic />} />
            <Route path="/rapoarte/stoc" element={<RapoarteStoc />} />
            <Route path="/rapoarte/fisa-magazie" element={<FisaMagazie />} />
            <Route path="/rapoarte/scaderi-materiale" element={<ScaderiMateriale />} />
            <Route
              path="/rapoarte/contabilitate"
              element={<RapoarteContabilitate />}
            />
            <Route path="/rapoarte/balanta" element={<Balanta />} />
            <Route path="/rapoarte/fisa-cont" element={<FisaCont />} />
            <Route path="/rapoarte/bilant" element={<Bilant />} />
            <Route path="/rapoarte/jurnal-tva" element={<JurnalTva />} />
            <Route
              path="/rapoarte/jurnal-tva/print"
              element={<JurnalTvaPrint />}
            />
            <Route
              path="/rapoarte/jurnal-tva-intrari-incasare"
              element={<JurnalTvaIntrariIncasare />}
            />
            <Route
              path="/rapoarte/jurnal-tva-valuta"
              element={<JurnalTvaValuta />}
            />
            <Route
              path="/rapoarte/jurnal-tva-iesiri-incasare"
              element={<JurnalTvaIesiriIncasare />}
            />
            <Route
              path="/rapoarte/jurnal-tva-iesiri-valuta"
              element={<JurnalTvaIesiriValuta />}
            />
            <Route
              path="/intrare/intrare_list/:account_id"
              element={<IntrareList />}
            />
            <Route
              path="/iesire/iesire_list/:account_id"
              element={<IesireList />}
            />
            <Route path="/efactura" element={<EFacturaList />} />
            <Route path="/d300" element={<D300List />} />
            <Route path="/d300/edit/:id" element={<D300Edit />} />
            <Route path="/d394" element={<D394List />} />
            <Route path="/d394/edit/:id" element={<D394Edit />} />
            <Route path="/d406" element={<D406List />} />
            <Route path="/d406/edit/:id" element={<D406Edit />} />
            <Route path="/nc" element={<NcList simpleMode={true} />} />
            <Route path="/nc/lista" element={<NcList simpleMode={false} />} />
            <Route path="/repartizari-centre" element={<CostAllocationReport />} />
            <Route path="/nc/new" element={<NcCreate />} />
            <Route path="/nc/edit/:rec_type/:doc_id" element={<NcEdit />} />
            <Route path="/nc/view/:rec_type/:doc_id" element={<NcView />} />
            <Route path="/inchide-luna" element={<InchideLuna />} />
            <Route path="/walkthrough" element={<Walkthrough />} />
            <Route path="/cont_cc_map" element={<ContCcMapList />} />
            <Route path="/cont-cc-map/create" element={<ContCcMapCreate />} />
            <Route path="/admin/drepturi" element={<UserRightsPage />} />
            <Route path="/admin/roluri" element={<RolesPage />} />
            <Route path="/admin/user" element={<UserListPage />} />
            <Route path="/admin/import-balanta" element={<ImportBalanta />} />
            <Route path="/admin/import-facturi" element={<ImportFacturi />} />
            <Route path="/admin/import-stoc" element={<ImportStoc />} />
            <Route path="/admin/import-mf" element={<ImportMf />} />
            <Route
              path="/comenzi/client/linii"
              element={<ClientOrderLinesList />}
            />
            <Route path="/comenzi/client/new" element={<ClientOrderCreate />} />
            <Route path="/comenzi/client/:id/print" element={<ClientOrderPrint />} />
            <Route
              path="/comenzi/client/edit/:id"
              element={<ClientOrderCreate />}
            />
            <Route
              path="/comenzi/intern/linii"
              element={<InternalOrdersList />}
            />
            <Route path="/coduri-manopera" element={<CoduriManopera />} />
            <Route path="/coduri-manopera-prod" element={<CoduriManoperaProd />} />
            <Route path="/angajati" element={<Angajati />} />
            <Route path="/rapoarte/manopera-angajati" element={<RaportAngajati />} />
            <Route path="/rapoarte/necesar-aprovizionare" element={<RaportNecesarAprovizionare />} />

            <Route path="/rapoarte/consum-teoretic-real" element={<RaportConsumProd />} />
            <Route path="/rapoarte/istoric-reparatii" element={<RaportIstoricSasiu />} />
            <Route path="/rapoarte/profitabilitate" element={<RaportProfitabilitateService />} />


              {/* Obiecte de Inventar */}
              <Route path="/obinv" element={<ObInvList />} />
              <Route path="/obinv/new" element={<ObInvForm />} />
              <Route path="/obinv/edit/:id" element={<ObInvForm />} />

              <Route path="/obinv/transfer" element={<TransferObInvList />} />
              <Route path="/obinv/transfer/new" element={<TransferObInvForm />} />
              <Route path="/obinv/transfer/edit/:id" element={<TransferObInvForm />} />

              <Route path="/obinv/raport-stoc" element={<ObInvRaportStoc />} />
              <Route path="/obinv/istoric-miscari" element={<ObInvIstoricMiscari />} />

              <Route path="/obinv/casare" element={<CasariList />} />
              <Route path="/obinv/casare/new" element={<CasariForm />} />
              <Route path="/obinv/casare/edit/:id" element={<CasariForm />} />

              <Route path="/istoric" element={<IstoricList />} />

              {/* Catch-All / Fallback */}
            <Route path="/contor/transfer-echipament" element={<ContorTransferEquipment />} />
            <Route path="/contor/facturare-client" element={<ContorClientBilling />} />
            <Route path="/contor/contracte/facturare/:id" element={<ContorBilling />} />
            <Route path="/contor/contracte/new" element={<ContorContractForm />} />
            <Route path="/contor/contracte/edit/:id" element={<ContorContractForm />} />
            <Route path="/contor/contracte" element={<ContorContracts />} />
            <Route path="/contor/grupe" element={<GrupeList />} />
            <Route path="/contor/grupe/new" element={<GrupaForm />} />
            <Route path="/contor/grupe/edit/:id" element={<GrupaForm />} />
            <Route path="/contor/echipamente" element={<EchipamenteList />} />
            <Route
              path="/contor/echipamente/new"
              element={<EchipamentForm />}
            />
            <Route
              path="/contor/echipamente/edit/:id"
              element={<EchipamentForm />}
            />
            <Route path="/contor/sesizari" element={<SesizariList />} />
            <Route path="/contor/sesizari/new" element={<SesizareForm />} />
            <Route
              path="/contor/sesizari/edit/:id"
              element={<SesizareForm />}
            />
          </Route>
        </Routes>
      </AuthProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </Router>
  );
}

export default App;
